import React, { useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { Box, LinearProgress } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
const MyTeam = () => {
  const labelList = [
    "Name and Account",
    "Status",
    "Credit Used",
    "Contacts Used",
    "Verification Used",
  ];
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [email, setEmail] = useState("");
  const [selectedMail, setSelectedMail] = useState("");
  const [inviteStatus, setInviteStatus] = useState(false);
  const [allInvite, setAllInvite] = useState([]);
  const [incomingInvite, setIncomingInvite] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [leaveTeam, setLeaveTeam] = useState(false);
  const [checkInvite, setCheckInvite] = useState(false);
  const [inviteLoad, setInviteLoad] = useState(false);
  const [progress, setProgress] = useState(70);
  const [showToast, setShowToast] = useState(false);
  function sendInvite() {
    let emailData = {
      inviteEmail: email,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/user/send-team-member-invitation/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getAllInvitedEmail();
          setEmail("");
        } else {
          setOpen2(true);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setInviteStatus(false);
      })
      .catch((err) => console.log("Error"));
  }
  function getAllInvitedEmail() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-team-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setAllInvite(response.data);
        } else {
          setAllInvite([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function getAvailableInvite() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/check-team-invitation/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setIncomingInvite(response.data.details);
          setCheckInvite(true);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllInvitedEmail();
    getAvailableInvite();
  }, []);
  function removeUserFromTeam() {
    let emailData = {
      removeEmail: selectedMail,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/remove-team-member/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getAllInvitedEmail();
          setOpen(false);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function revertUserFromTeam() {
    let emailData = {
      inviteEmail: selectedMail,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/user/revert-team-member-invitation/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getAllInvitedEmail();
          setOpen(false);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function leaveTeamUser() {
    let emailData = {
      headEmail: allInvite.details.HeadEmail,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/leave-team/${
          userDetails && userDetails.details._id
        }`,
        emailData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getAllInvitedEmail();
          setOpen(false);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function joinTeamByLink(id) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user/accept-invitation/${
        userDetails && userDetails.details._id
      }/${id}`,
      headers: {
        Authorization: `Bearear ${userDetails && userDetails.token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.status) {
          setInviteLoad(false);
          setCheckInvite(false);
          getAllInvitedEmail();
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function isValidEmail(email) {
    // Regular expression pattern for a valid email address
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    return emailPattern.test(email);
  }
  return (
    <div style={{ padding: "16px" }}>
      {checkInvite && (
        <>
          {incomingInvite.map((val) => {
            return (
              <div className="inivitecheckfullbox">
                <div className="invitechecnbox">
                  Team Invite {val.teamMain.HeadEmail}! Join by clicking here or
                  via a link in an invitation email we send you.
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div
                    className="createCampaignfilledbutton"
                    onClick={() => {
                      setInviteLoad(true);
                      joinTeamByLink(val.teamMain._id);
                    }}
                  >
                    {inviteLoad ? (
                      <CircularProgress
                        size={19}
                        style={{
                          color: "white",
                          marginLeft: "6px",
                          marginRight: "6px",
                        }}
                      />
                    ) : (
                      "Join Team"
                    )}
                  </div>
                  <div
                    className="addemailaccountbutton"
                    onClick={() => {
                      setCheckInvite(false);
                    }}
                  >
                    Close
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}

      {allInvite.length === 0 ? (
        <div style={{ gap: "32px", display: "flex", flexDirection: "column" }}>
          <div>
            <h1
              style={{
                color: "#434343",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Source Sans 3",
                lineHeight: "20px",
              }}
            >
              My Team
            </h1>
            <p
              style={{
                color: "#434343",
                fontSize: "15px",
                fontWeight: 400,
                fontFamily: "Source Sans 3",
              }}
            >
              Invite users to your team to share your account credits and
              recipients. Plus, unlock team CRM features, share data and
              templates, manage permissions and analyze each member’s input on
              any Pro plan.
              {/* <span className="viewplanstyle">View plans.</span> */}
            </p>
          </div>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            <input
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="text"
              style={{
                backgroundColor: "#FAFAFA",
                color: "#B0B0B0",
                padding: "10px",
                borderRadius: "6px",
                outline: "none",
                width: "20vw",
                border: "1px solid #1C485F",
              }}
              placeholder="example@domain.com"
            />
            <button
              onClick={() => {
                if (isValidEmail(email)) {
                  setInviteStatus(true);
                  sendInvite();
                } else {
                  setShowToast(true);
                  toast.error("Invalid Email! Please Enter valid email", {
                    autoClose: true,
                    position: "top-right",
                    duration: 3000,
                  });
                }
              }}
              style={{
                backgroundColor: "#FF3301",
                color: "#fff",
                padding: "10px",
                borderRadius: "6px",
                outline: "none",
              }}
            >
              {inviteStatus ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress
                    size={19}
                    style={{
                      color: "white",
                      marginLeft: "6px",
                      marginRight: "6px",
                    }}
                  />
                </div>
              ) : (
                "Invite"
              )}
            </button>
          </div>
        </div>
      ) : (
        <>
          {!allInvite.teamHead ? (
            <div className="myteaminvietes">
              <div className="myteaminsidebox">
                <div className="myteamdescbox">
                  <div className="myteamheadtext">My Team</div>
                  <div className="teamleaddeschead">Team lead login</div>
                  <div className="teamleadmeaintext">
                    {allInvite.length !== 0 && allInvite.details.HeadEmail}
                  </div>
                </div>
                <div
                  onClick={() => {
                    setLeaveTeam(true);
                    setOpen(true);
                  }}
                  className="addemailaccountbutton"
                >
                  Leave Team
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                    }}
                  >
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                      }}
                    >
                      email credits used
                    </p>
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        marginTop: "0px",
                      }}
                    >
                      {allInvite.plan.SubscriptionDetails.EmailLimit -
                        allInvite.plan.EmailLimit}{" "}
                      /{allInvite.plan.SubscriptionDetails.EmailLimit}
                    </p>
                  </div>
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress
                      variant="determinate"
                      value={
                        ((allInvite.plan.SubscriptionDetails.EmailLimit -
                          allInvite.plan.EmailLimit) /
                          allInvite.plan.SubscriptionDetails.EmailLimit) *
                        100
                      }
                      sx={{
                        padding: "4px 0px",
                        borderRadius: "6px",
                        backgroundColor: "#F3F3F3",
                      }}
                    />
                  </Box>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                    }}
                  >
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                      }}
                    >
                      Unique contacts used by team
                    </p>
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        marginTop: "0px",
                      }}
                    >
                      {allInvite.plan.SubscriptionDetails.ContactLimit -
                        allInvite.plan.ContactLimit}{" "}
                      /{allInvite.plan.SubscriptionDetails.ContactLimit}
                    </p>
                  </div>
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress
                      variant="determinate"
                      value={
                        ((allInvite.plan.SubscriptionDetails.ContactLimit -
                          allInvite.plan.ContactLimit) /
                          allInvite.plan.SubscriptionDetails.ContactLimit) *
                        100
                      }
                      sx={{
                        padding: "4px 0px",
                        borderRadius: "6px",
                        backgroundColor: "#F3F3F3",
                      }}
                    />
                  </Box>
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "5px",
                    }}
                  >
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                      }}
                    >
                      Unique verification used by team
                    </p>
                    <p
                      style={{
                        color: "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        marginTop: "0px",
                      }}
                    >
                      {allInvite.plan.SubscriptionDetails
                        .EmailVerificationLimit -
                        allInvite.plan.EmailVerificationLimit}{" "}
                      /
                      {
                        allInvite.plan.SubscriptionDetails
                          .EmailVerificationLimit
                      }
                    </p>
                  </div>
                  <Box sx={{ width: "100%" }}>
                    <LinearProgress
                      variant="determinate"
                      value={
                        ((allInvite.plan.SubscriptionDetails
                          .EmailVerificationLimit -
                          allInvite.plan.EmailVerificationLimit) /
                          allInvite.plan.SubscriptionDetails
                            .EmailVerificationLimit) *
                        100
                      }
                      sx={{
                        padding: "4px 0px",
                        borderRadius: "6px",
                        backgroundColor: "#F3F3F3",
                      }}
                    />
                  </Box>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div
                style={{
                  gap: "32px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <h1
                    style={{
                      color: "#434343",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Source Sans 3",
                      lineHeight: "20px",
                    }}
                  >
                    My Team
                  </h1>
                  <p
                    style={{
                      color: "#434343",
                      fontSize: "15px",
                      fontWeight: 400,
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    Invite users to your team to share your account credits and
                    recipients. Plus, unlock team CRM features, share data and
                    templates, manage permissions and analyze each member’s
                    input on any Pro plan.{" "}
                    {/* <span className="viewplanstyle">View plans.</span> */}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    alignItems: "center",
                    marginBottom: "30px",
                  }}
                >
                  <input
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    type="text"
                    style={{
                      backgroundColor: "#FAFAFA",
                      color: "#B0B0B0",
                      padding: "10px",
                      borderRadius: "6px",
                      outline: "none",
                      width: "20vw",
                      border: "1px solid #1C485F",
                    }}
                    placeholder="example@domain.com"
                  />
                  <button
                    onClick={() => {
                      if (isValidEmail(email)) {
                        setInviteStatus(true);
                        sendInvite();
                      } else {
                        setShowToast(true);
                        toast.error("Invalid Email! Please Enter valid email", {
                          autoClose: true,
                          position: "top-right",
                          duration: 3000,
                        });
                      }
                    }}
                    style={{
                      backgroundColor: "#FF3301",
                      color: "#fff",
                      padding: "10px",
                      borderRadius: "6px",
                      outline: "none",
                    }}
                  >
                    {inviteStatus ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CircularProgress
                          size={19}
                          style={{
                            color: "white",
                            marginLeft: "6px",
                            marginRight: "6px",
                          }}
                        />
                      </div>
                    ) : (
                      "Invite"
                    )}
                  </button>
                </div>
              </div>
              {allInvite.details.MembersDetails.length !== 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        email credits used
                      </p>
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          marginTop: "0px",
                        }}
                      >
                        {allInvite.plan.SubscriptionDetails.EmailLimit -
                          allInvite.plan.EmailLimit}{" "}
                        /{allInvite.plan.SubscriptionDetails.EmailLimit}
                      </p>
                    </div>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={
                          ((allInvite.plan.SubscriptionDetails.EmailLimit -
                            allInvite.plan.EmailLimit) /
                            allInvite.plan.SubscriptionDetails.EmailLimit) *
                          100
                        }
                        sx={{
                          padding: "4px 0px",
                          borderRadius: "6px",
                          backgroundColor: "#F3F3F3",
                        }}
                      />
                    </Box>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Unique contacts used by team
                      </p>
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          marginTop: "0px",
                        }}
                      >
                        {allInvite.plan.SubscriptionDetails.ContactLimit -
                          allInvite.plan.ContactLimit}{" "}
                        /{allInvite.plan.SubscriptionDetails.ContactLimit}
                      </p>
                    </div>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={
                          ((allInvite.plan.SubscriptionDetails.ContactLimit -
                            allInvite.plan.ContactLimit) /
                            allInvite.plan.SubscriptionDetails.ContactLimit) *
                          100
                        }
                        sx={{
                          padding: "4px 0px",
                          borderRadius: "6px",
                          backgroundColor: "#F3F3F3",
                        }}
                      />
                    </Box>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "5px",
                      }}
                    >
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                        }}
                      >
                        Unique verification used by team
                      </p>
                      <p
                        style={{
                          color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          marginTop: "0px",
                        }}
                      >
                        {allInvite.plan.SubscriptionDetails
                          .EmailVerificationLimit -
                          allInvite.plan.EmailVerificationLimit}{" "}
                        /
                        {
                          allInvite.plan.SubscriptionDetails
                            .EmailVerificationLimit
                        }
                      </p>
                    </div>
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress
                        variant="determinate"
                        value={
                          ((allInvite.plan.SubscriptionDetails
                            .EmailVerificationLimit -
                            allInvite.plan.EmailVerificationLimit) /
                            allInvite.plan.SubscriptionDetails
                              .EmailVerificationLimit) *
                          100
                        }
                        sx={{
                          padding: "4px 0px",
                          borderRadius: "6px",
                          backgroundColor: "#F3F3F3",
                        }}
                      />
                    </Box>
                  </div>
                </div>
              )}

              <div className="invitelistwholebox">
                <div className="inviteboxinsidebox">
                  {allInvite.length !== 0 &&
                    allInvite.details.MembersDetails.length !== 0 && (
                      <>
                        <div className="inviteboxtopbox">
                          {labelList.map((val, idx) => (
                            <div
                              className="inviteboxtextlabel"
                              style={{ width: idx === 0 && "13vw" }}
                            >
                              {val}
                            </div>
                          ))}
                        </div>
                        {allInvite.details.MembersDetails.map((val) => {
                          let atIndex = val.Email.indexOf("@");
                          let name;
                          if (atIndex !== -1) {
                            name = val.Email.substring(0, atIndex);
                          } else {
                            console.log("Invalid email address");
                          }
                          return (
                            <div className="inviteboxbottombox">
                              <div
                                className="inviteboxnameemail"
                                style={{ width: "15vw" }}
                              >
                                <div className="indisdeboxnamemail">
                                  <div className="unvitenameavatar">
                                    {val.Email.substring(0, 2).toUpperCase()}
                                  </div>
                                  <div className="invitenameemal">
                                    <div className="nameofemail">{name}</div>
                                    <div className="inviteemail">
                                      {val.Email}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="inviteboxnameemail">
                                {val.Status === "Accepted" ? (
                                  <div className="acceptedinvitebox">
                                    In-Team
                                  </div>
                                ) : (
                                  <div className="statsusstyleinvite">
                                    {val.Status}
                                  </div>
                                )}
                              </div>
                              <div className="inviteboxnameemail">
                                {val.EmailCreditUsed}
                              </div>
                              <div className="inviteboxnameemail">
                                {val.ContactCreditUsed}
                              </div>
                              <div
                                className="inviteboxnameemail"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  flexDirection: "row",
                                }}
                              >
                                <div>{val.VerificationCreditUsed}</div>
                                <div>
                                  <svg
                                    onClick={() => {
                                      setSelectedMail(val.Email);
                                      setLeaveTeam(false);
                                      if (val.Status === "Accepted") {
                                        setOpen(true);
                                        setDeleteStatus(true);
                                      } else {
                                        setOpen(true);
                                        setDeleteStatus(false);
                                      }
                                    }}
                                    style={{ cursor: "pointer" }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M21.5996 6.48047C18.2696 6.15047 14.9196 5.98047 11.5796 5.98047C9.59961 5.98047 7.61961 6.08047 5.63961 6.28047L3.59961 6.48047"
                                      stroke="#868686"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.09961 5.47L9.31961 4.16C9.47961 3.21 9.59961 2.5 11.2896 2.5H13.9096C15.5996 2.5 15.7296 3.25 15.8796 4.17L16.0996 5.47"
                                      stroke="#868686"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M19.45 9.64062L18.8 19.7106C18.69 21.2806 18.6 22.5006 15.81 22.5006H9.39C6.6 22.5006 6.51 21.2806 6.4 19.7106L5.75 9.64062"
                                      stroke="#868686"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10.9297 17H14.2597"
                                      stroke="#868686"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10.0996 13H15.0996"
                                      stroke="#868686"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </>
                    )}
                </div>
              </div>
            </>
          )}
        </>
      )}
      {showToast && <ToastContainer />}
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">
            {leaveTeam
              ? "Confirm to leave team"
              : `Confirm ${deleteStatus ? "Remove" : "Revert"}`}
          </div>
          <div className="modalsubtext">
            {leaveTeam
              ? "Are you sure you want to leave team?"
              : `${
                  deleteStatus
                    ? "Are you sure you want to Remove this user from team ?"
                    : "Are you sure you want to Revert this user from joining team ?"
                }`}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                if (leaveTeam) {
                  leaveTeamUser();
                } else {
                  if (deleteStatus) {
                    removeUserFromTeam();
                  } else {
                    revertUserFromTeam();
                  }
                }
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        open={open2}
        onClose={() => {
          setOpen2(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Can't invite user</div>
          <div className="modalsubtext">
            This user is already in another team
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="continuebuttonmodal"
              onClick={() => {
                setEmail("");
                setOpen2(false);
              }}
            >
              Ok
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default MyTeam;
